import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useDialogFocus } from '../hooks/useDialogFocus.js';
import './DocumentOverlay.css';

// A portal escapes the vehicle page's transformed/animated stacking context.
export default function DocumentOverlay({ children, onClose, labelledBy, testId, compact = false, returnFocusRef }) {
    const ref = useDialogFocus(onClose, true, returnFocusRef);
    useEffect(() => {
        const previous = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = previous; };
    }, []);
    return createPortal(<div className="wms-document-overlay" dir="rtl" data-testid={testId}>
        <section ref={ref} role="dialog" aria-modal="true" aria-labelledby={labelledBy}
            className={`wms-document-dialog${compact ? ' wms-document-dialog--compact' : ''}`}>
            {children}
        </section>
    </div>, document.body);
}
